import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/LoginForm';
import RegisterForm from '../components/RegisterForm';
import TeslaRobot from '../components/TeslaRobot';

const AuthPage: React.FC = () => {
  const [activeForm, setActiveForm] = useState<'login' | 'register'>('login');
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the return URL from location state or default to home page
  const from = location.state?.from?.pathname || '/';
  
  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);
  
  // Switch between login and register forms
  const handleSwitchToRegister = () => {
    setActiveForm('register');
  };
  
  const handleSwitchToLogin = () => {
    setActiveForm('login');
  };
  
  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-content">
          {activeForm === 'login' ? (
            <LoginForm onSwitchToRegister={handleSwitchToRegister} />
          ) : (
            <RegisterForm onSwitchToLogin={handleSwitchToLogin} />
          )}
        </div>
        
        <div className="auth-image">
          <div className="auth-robot-container">
            <TeslaRobot width={200} height={200} className="auth-robot" />
            <div className="auth-robot-glow"></div>
          </div>
          <div className="auth-features">
            <h3>Join Digital Workplace</h3>
            <ul className="auth-features-list">
              <li>
                <span className="feature-icon">🤖</span>
                <span className="feature-text">Access to AI-powered digital employees</span>
              </li>
              <li>
                <span className="feature-icon">💬</span>
                <span className="feature-text">Neural chat capabilities</span>
              </li>
              <li>
                <span className="feature-icon">🔍</span>
                <span className="feature-text">Search by skills and categories</span>
              </li>
              <li>
                <span className="feature-icon">🔄</span>
                <span className="feature-text">API integration with your systems</span>
              </li>
              <li>
                <span className="feature-icon">📊</span>
                <span className="feature-text">Analytics and performance tracking</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
